import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { Card } from "../components/ui/card";
import { BLOGS } from "../lib/blogs";
import { Clock, ArrowRight, BookOpen } from "lucide-react";

export default function BlogList() {
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <section className="bg-gradient-to-br from-teal-700 to-teal-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 text-[11px] font-semibold uppercase tracking-[0.2em]">
            <BookOpen className="w-3.5 h-3.5"/> Health Blogs
          </div>
          <h1 className="mt-4 font-heading text-4xl sm:text-5xl font-bold leading-tight">
            Neuro &amp; spine care,<br/>explained in plain English.
          </h1>
          <p className="mt-3 text-white/80 max-w-2xl">
            Written and reviewed by NeuroOpinion India specialists — NIMHANS and AIIMS alumni.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOGS.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              className="group"
              data-testid={`blog-list-card-${p.slug}`}
            >
              <Card className="overflow-hidden border-slate-200 lift h-full flex flex-col">
                <div className="aspect-[16/10] w-full overflow-hidden bg-gradient-to-br from-teal-50 to-blue-50 relative">
                  {p.cover && (
                    <img
                      src={p.cover}
                      alt={p.title}
                      className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                  )}
                  <span className="absolute top-3 left-3 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-white/90 text-teal-700 border border-teal-200">
                    {p.category}
                  </span>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <h3 className="font-heading font-semibold text-lg text-slate-900 leading-snug group-hover:text-teal-700 transition">{p.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 line-clamp-3 flex-1">{p.excerpt}</p>
                  <div className="mt-4 flex items-center justify-between text-xs text-slate-500 pt-3 border-t border-slate-100">
                    <span className="inline-flex items-center gap-1"><Clock className="w-3.5 h-3.5"/>{p.read_minutes} min</span>
                    <span className="text-teal-700 font-semibold inline-flex items-center gap-1">
                      Read <ArrowRight className="w-3.5 h-3.5"/>
                    </span>
                  </div>
                </div>
              </Card>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
